
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.952 9.952C7 12.905 7 17.657 7 27.16v1.68c0 9.503 0 14.255 2.952 17.208C12.905 49 17.657 49 27.16 49h1.68c9.503 0 14.255 0 17.208-2.952C49 43.095 49 38.343 49 28.84v-1.68c0-9.503 0-14.255-2.952-17.208C43.095 7 38.343 7 28.84 7h-1.68C17.657 7 12.905 7 9.952 9.952zm16.12 23.725c-.931-.647-1.546-1.195 0-2.706.593-.58 1.373-1.314 2.225-2.118 1.368-1.29 2.925-2.758 4.207-4.05.216-.218.5-.567.236-.819-.264-.251-.66-.004-1.004.22-.069.044-.401.268-.902.606-2.017 1.362-6.767 4.57-8.008 5.279-.037.02-.074.042-.11.063-1.02.585-1.828 1.05-4.302.426-.5-.126-2.599-.791-3.108-1.049-.569-.286-1.406-.998.51-1.843 2.024-.892 18.053-7.628 19.712-8.266 1.153-.443 2.247-.758 2.789-.33.42.33.524.909.357 2.374-.225 1.977-2.29 14.624-2.672 15.843l-.019.06c-.18.588-.728 2.386-3.434.65-2.804-1.798-4.259-2.798-6.477-4.34z","fill":"#52A8E5"}})])
          )
        }
      }
    